import Vue from 'vue'
import Router from 'vue-router'
import fund from './fund'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [{
  path: '/login',
  component: () => import('@/views/login/index'),
  hidden: true
},
{
  path: '/404',
  component: () => import('@/views/404'),
  hidden: true
},
  // {
  //   path: '',
  //   component: Layout,
  //   redirect: '/home',
  //   meta: {
  //     title: '首页',
  //     icon: 'home'
  //   },
  //   children: [{
  //       path: 'home',
  //       name: 'home',
  //       component: () => import('@/views/home/index'),
  //       meta: {
  //         title: '仪表盘',
  //         icon: 'dashboard'
  //       }
  //     },
  //   ]
  // }
]

export const asyncRouterMap = [
  {
    path: '',
    component: Layout,
    redirect: '/home',
    name: 'home',
    meta: {
      title: '仪表盘',
      icon: 'home'
    },
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {
        title: '仪表盘',
        icon: 'dashboard'
      }
    },
    ]
  },
  {
    path: '/agent',
    component: Layout,
    redirect: '/agent/agentInfo',
    name: 'agent',
    meta: {
      title: '业务管理',
      icon: 'product-list'
    },
    children: [{
      path: 'agentInfo',
      name: 'agentInfo',
      component: () => import('@/views/agent/agentInfo/index'),
      meta: {
        title: '业务账号管理',
        icon: 'product-list',
        iskeepAlive: true
      }
    }, {
      path: 'agentOrder',
      name: 'agentOrder',
      component: () => import('@/views/agent/agentOrder/index'),
      meta: {
        title: '订单管理',
        icon: 'product-list',
        iskeepAlive: true
      }
    },
    ]
  },
  {
    path: '/merchantSelf',
    component: Layout,
    redirect: '/merchantSelf/merchantAccount',
    name: 'merchantSelf',
    meta: {
      title: '渠道自服务',
      icon: 'product-list'
    },
    children: [{
      path: 'merchantAccount',
      name: 'merchantAccount',
      component: () => import('@/views/merchantSelf/merchantAccount/index'),
      meta: {
        title: '组织管理',
        icon: 'product-list',
        iskeepAlive: true
      }
    }, {
      path: 'merchantOrder',
      name: 'merchantOrder',
      component: () => import('@/views/merchantSelf/merchantOrder/index'),
      meta: {
        title: '订单管理',
        icon: 'product-list',
        iskeepAlive: true
      }
    }, {
      path: 'merchantReturn',
      name: 'merchantReturn',
      component: () => import('@/views/merchantSelf/merchantReturn/index'),
      meta: {
        title: '付款管理',
        icon: 'product-list',
        iskeepAlive: true
      }
    }, {
      path: 'overdueList',
      name: 'overdueList',
      component: () => import('@/views/merchantSelf/overdueList/index'),
      meta: {
        title: '逾期名单列表',
        icon: 'product-list',
        iskeepAlive: true
      }
    }, {
      path: 'billList',
      name: 'billList',
      component: () => import('@/views/merchantSelf/billList/index'),
      meta: {
        title: '账单查询列表',
        icon: 'product-list',
        iskeepAlive: true
      }
    }, 
    ]
  },
  {
    path: '/statisticalReport',
    component: Layout,
    redirect: '/statisticalReport/paymentCalculationTable',
    name: 'statisticalReport',
    meta: {
      title: '统计报表',
      icon: 'product-list'
    },
    children: [
      {
        path: 'paymentCalculationTable',
        name: 'paymentCalculationTable',
        component: () => import('@/views/statisticalReport/paymentCalculationTable/index'),
        meta: {
          title: '回款测算表',
          icon: 'order-setting',
          iskeepAlive: true
        }
      },
      {
        path: 'businessReport',
        name: 'businessReport',
        component: () => import('@/views/statisticalReport/businessReport/index'),
        meta: {
          title: '经营数据汇报',
          icon: 'order-setting',
          iskeepAlive: true
        }
      },
      {
        path: 'merDataAnalysis',
        name: 'merDataAnalysis',
        component: () => import('@/views/statisticalReport/merDataAnalysis/index'),
        meta: {
          title: '渠道数据分析',
          icon: 'order-setting',
          iskeepAlive: true
        }
      },
      {
        path: 'payDataStatistics',
        name: 'payDataStatistics',
        component: () => import('@/views/statisticalReport/payDataStatistics/index'),
        meta: {
          title: '付款数据统计',
          icon: 'order-setting',
          iskeepAlive: true
        }
      },
    ]
  },
  {
    path: '/oms',
    component: Layout,
    redirect: '/oms/order',
    name: 'oms',
    meta: {
      title: '订单',
      icon: 'order',
    },
    children: [
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/oms/order/index'),
        // component: () => import('@/views/oms/order/tabCom/index'),
        meta: {
          title: '订单列表',
          icon: 'product-list',
          iskeepAlive: true,
        }
      },{
        path: 'orderImg',
        name: 'orderImg',
        component: () => import('@/views/oms/orderImg/index'),
        meta: {
          title: '业务二维码',
          icon: 'product-list',
          iskeepAlive: true,
        }
      }, {
        path: 'pureBillList',
        name: 'pureBillList',
        component: () => import('@/views/oms/pureBillList/index'),
        meta: {
          title: '纯账单列表',
          icon: 'product-list',
          iskeepAlive: true,
        }
      },
      //订单tabCom详情页面
      {
        path: 'orderDetail',
        name: 'orderDetail',
        component: () => import('@/views/oms/order/tabCom/index'),
        meta: {
          title: '订单列表详情',
        },
        hidden: true
      },
      {
        path: 'orderReject',
        name: 'orderReject',
        component: () => import('@/views/oms/orderReject/index'),
        meta: {
          title: '拒单查询',
          icon: 'order-setting',
          iskeepAlive: true
        }
      },
      {
        path: 'orderSetting',
        name: 'orderSetting',
        component: () => import('@/views/oms/order1/setting'),
        meta: {
          title: '订单设置',
          icon: 'order-setting'
        },
      },
      {
        path: 'orderCancel',
        name: 'orderCancel',
        component: () => import('@/views/oms/orderCancel/index'),
        meta: {
          title: '订单取消审批',
          icon: 'order-setting',
          iskeepAlive: true
        },
      },
      {
        path: 'orderRepApproval',
        name: 'orderRepApproval',
        component: () => import('@/views/oms/orderRepApproval/index'),
        meta: {
          title: '订单回购审批',
          icon: 'order-setting',
          iskeepAlive: true
        },
      },
    ]
  },
  {
    path: '/system',
    component: Layout,
    redirect: '/system/notice',
    name: 'System',
    meta: {
      title: '系统',
      icon: 'system'
    },
    children: [{
      path: 'notice',
      name: 'Notice',
      component: () => import('@/views/system/notice/index'),
      meta: {
        title: '公告管理',
        icon: 'system-notice',
        iskeepAlive: true
      }
    },
    {
      path: 'params',
      name: 'Params',
      component: () => import('@/views/system/params/index'),
      meta: {
        title: '参数配置',
        icon: 'system-aboutus',
        iskeepAlive: true
      }
    },
    ]
  },
  {
    path: '/user',
    component: Layout,
    redirect: '/user/userList',
    name: 'User',
    meta: {
      title: '用户',
      icon: 'system'
    },
    children: [{
      path: 'userList',
      name: 'UserList',
      component: () => import('@/views/user/userList/index'),
      meta: {
        title: '用户列表',
        icon: 'user-yonghu',
        iskeepAlive: true
      }
    }, {
      path: 'userVerification',
      name: 'userVerification',
      component: () => import('@/views/user/userVerification/index'),
      meta: {
        title: '用户验证',
        icon: 'user-yonghu',
        iskeepAlive: true
      }
    },
    {
      path: 'listenClassInquiry',
      name: 'listenClassInquiry',
      component: () => import('@/views/user/listenClassInquiry/index'),
      meta: {
        title: '听课查询',
        icon: 'user-yonghu',
        iskeepAlive: true
      }
    },
    ]
  },




  {
    path: '/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {
      title: '权限',
      icon: 'ums'
    },
    children: [{
      path: 'admin',
      name: 'admin',
      component: () => import('@/views/ums/admin/index'),
      meta: {
        title: '用户列表',
        icon: 'ums-admin'
      }
    },
    {
      path: 'role',
      name: 'role',
      component: () => import('@/views/ums/role/index'),
      meta: {
        title: '角色列表',
        icon: 'ums-role'
      }
    },
    {
      path: 'allocMenu',
      name: 'allocMenu',
      component: () => import('@/views/ums/role/allocMenu'),
      meta: {
        title: '分配菜单'
      },
      hidden: true
    },
    {
      path: 'allocResource',
      name: 'allocResource',
      component: () => import('@/views/ums/role/allocResource'),
      meta: {
        title: '分配资源'
      },
      hidden: true
    },
    {
      path: 'menu',
      name: 'menu',
      component: () => import('@/views/ums/menu/index'),
      meta: {
        title: '菜单列表',
        icon: 'ums-menu'
      }
    },
    {
      path: 'addMenu',
      name: 'addMenu',
      component: () => import('@/views/ums/menu/add'),
      meta: {
        title: '添加菜单'
      },
      hidden: true
    },
    {
      path: 'updateMenu',
      name: 'updateMenu',
      component: () => import('@/views/ums/menu/update'),
      meta: {
        title: '修改菜单'
      },
      hidden: true
    },
    {
      path: 'resource',
      name: 'resource',
      component: () => import('@/views/ums/resource/index'),
      meta: {
        title: '资源列表',
        icon: 'ums-resource'
      }
    },
    {
      path: 'resourceCategory',
      name: 'resourceCategory',
      component: () => import('@/views/ums/resource/categoryList'),
      meta: {
        title: '资源分类'
      },
      hidden: true
    }
    ]
  },

  {
    path: '/companyManage',
    component: Layout,
    redirect: '/companyManage/companyList',
    name: 'companyManage',
    meta: {
      title: '客户管理',
      icon: 'ums'
    },
    children: [
      {
        path: 'companyList',
        name: 'companyList',
        component: () => import('@/views/companyManage/index'),
        meta: {
          title: '客户管理',
          icon: 'ums-admin',
          iskeepAlive: true
        }
      },
      {
        path: 'companyLog',
        name: 'companyLog',
        component: () => import('@/views/companyManage/companyLog'),
        meta: {
          title: '拜访管理',
          icon: 'product-list',
          iskeepAlive: true
        }
      }
    ]
  },

  {
    path: '*',
    redirect: '/404',
    hidden: true
  },
  fund,
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js